<template>
  <div class="missions__one__table">
    <table cellpadding="0" cellspacing="0">
      <thead>
        <th>
          <i class="icon icon-menu"></i>
        </th>
        <th>{{ $t("missions.list.description") }}</th>
        <th>{{ $t("missions.list.progress") }}</th>
        <th>{{ $t("missions.list.reward") }}</th>
      </thead>
      <tbody>
        <tr v-for="(mission, index) in getMissionList" :key="index">
          <td>
            <i v-if="missionCompleted(mission)" class="icon icon-check"></i>
            <span v-else>{{ missionIndex(index) }}</span>
          </td>
          <td :class="{ 'mission__text--complete': missionCompleted(mission) }">
            {{ mission.title }}
          </td>
          <td>
            <div class="progress">
              <span v-if="!missionCompleted(mission)"
                >{{ getMissionProgress(mission) }} / {{ mission.target_count }}</span
              >
              <span v-else>{{ $t("missions.list.done") }}</span>
              <ProgressLine class="progress__line--white" :current="getProgressProcent(mission)" />
            </div>
          </td>
          <td>
            <MissionListOneInfoRewards
              :index="index"
              :missionRewards="getMissionRewards(mission)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProgressLine from "../../Common/ProgressLine";
import MissionListOneInfoRewards from "./MissionsListOneInfoRewards";

export default {
  name: "MissionsOneTable",
  components: {
    ProgressLine,
    MissionListOneInfoRewards,
  },
  computed: {
    ...mapGetters("missions", ["getMissionList"]),
  },
  methods: {
    missionIndex(index) {
      return `${("0" + (index + 1)).slice(-2)}`;
    },
    missionCompleted(mission) {
      return mission.is_complete;
    },
    getProgressProcent(mission) {
      return Math.ceil((this.getMissionProgress(mission) / mission.target_count) * 100);
    },
    getMissionProgress(mission) {
      return mission.progress >= mission.target_count ? mission.target_count : mission.progress;
    },
    getMissionRewards(mission) {
      return mission.rewards.slice().reverse();
    },
  },
};
</script>
